// Keys that can lead to prototype pollution
const DANGEROUS_KEYS = new Set(["__proto__", "constructor", "prototype"]);

export const normalizeBigInt = (obj: any): any => {
  if (obj === null || obj === undefined) return obj;
  if (typeof obj === "bigint") return obj.toString();

  if (Array.isArray(obj)) return obj.map(normalizeBigInt);
  if (obj instanceof Date) return obj;
  if (obj instanceof RegExp) return obj;
  if (obj instanceof Map) {
    const result = new Map();
    for (const [k, v] of obj) {
      result.set(normalizeBigInt(k), normalizeBigInt(v));
    }
    return result;
  }
  if (obj instanceof Set) {
    const result = new Set();
    for (const v of obj) {
      result.add(normalizeBigInt(v));
    }
    return result;
  }
  if (typeof obj === "object") {
    const result: any = Object.getPrototypeOf(obj) === null ? Object.create(null) : {};
    for (const key of Object.keys(obj)) {
      // Skip dangerous keys that could enable prototype pollution
      if (DANGEROUS_KEYS.has(key)) continue;
      result[key] = normalizeBigInt(obj[key]);
    }
    return result;
  }
  return obj;
};
